import { Flex, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react'

import { About } from '../profile/about'
import { Address } from '../profile/address'
import { CommunicationDetails } from '../profile/communicationDetails'
import { Family } from '../profile/family'
import { ProfessionalBackground } from '../profile/professionalBackground'
import React, { useRef, useState } from 'react'
import { UserDetails } from 'src/types/userDetails'
import { mapUserDetailsToProfileDto } from 'src/utils/profileMapper'
import { UserAvatarIcon } from 'src/resources/icons'
import RejectReasonModal from './dashboard/RejectReasonModal'
import {
  STATUS_APPROVED,
  STATUS_REJECTED,
  ACTION_APPROVE,
  ACTION_REJECT
} from 'src/common/constants/statusConstants'


interface Props {
  isOpen: boolean;
  onClose: () => void;
  user: UserDetails | null;
  approveUserApplication: (
    users: UserDetails[],
    action: typeof STATUS_APPROVED | typeof STATUS_REJECTED,
    reason?: string
  ) => Promise<void>;
}


export const DetailModal: React.FC<Props> = ({ user, isOpen, onClose, approveUserApplication}) => {
    const profileData = mapUserDetailsToProfileDto(user);
    const leastRef = useRef<HTMLButtonElement | null>(null);

const [isRejectOpen, setIsRejectOpen] = useState(false);
const [rejectReason, setRejectReason] = useState("");

const [isApproveOpen, setIsApproveOpen] = useState(false);
const [approveReason, setApproveReason] = useState("");

const confirmReject = async () => {
  if (!user) return;
  await approveUserApplication([user], STATUS_REJECTED, rejectReason);
  setIsRejectOpen(false);
  onClose();
};

const confirmApprove = async () => {
  if (!user) return;
  await approveUserApplication([user], STATUS_APPROVED, approveReason || undefined);
  setIsApproveOpen(false);
  onClose();
};


  return (
    <>
    <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
        <ModalOverlay/>
        <ModalContent
            maxW={{ base: "100%", md: "65%" }}
            minH={{ base: "100%", md: "85%" }}
        >
        <ModalHeader>
        {/* Inline avatar + name */}
        <HStack alignItems="center" spacing={3}>
            <UserAvatarIcon fontSize="sm" />
            <Text fontSize="20px" fontWeight={500} lineHeight="20px">
                {user?.personalDetails?.firstName}
            </Text>
        </HStack>
        <Flex direction="column" alignItems="center" alignContent="space-around">
            <div>
                <button
                style={{
                    padding:"12px",
                    backgroundColor:"#E35E00",
                    border:"2px solid #E35E00",
                    borderColor:"#E35E00",
                    borderRadius:"4px",
                    marginRight:"10px",
                    color:"white"
                    }}
                    onClick={() => setIsApproveOpen(true)}
                >
                    {ACTION_APPROVE}
                </button>
                <button style={{
                    padding:"12px",
                    backgroundColor:"white",
                    border:"2px solid #E35E00",
                    borderColor:"#F1B4B4",
                    borderRadius:"4px",
                    color:"#E35E00"
                    }}
                    onClick={() => setIsRejectOpen(true)}
                >
                    {ACTION_REJECT}
                </button>
            </div>
        </Flex>
        </ModalHeader>
        <ModalCloseButton/>
        <ModalBody>
  <Tabs variant="unstyled">
    <TabList alignContent="center" justifyContent="space-between" width="100%">
      <Tab>About</Tab>
      <Tab>Address</Tab>
      <Tab>Communication Details</Tab>
      <Tab>Professional Background</Tab>
      <Tab>Family</Tab>
    </TabList>

    <TabPanels>
      <TabPanel>
        <About userData={profileData} />
      </TabPanel>
      <TabPanel>
        <Address userData={profileData} />
      </TabPanel>
      <TabPanel>
        <CommunicationDetails userData={profileData} />
      </TabPanel>
      <TabPanel>
        <ProfessionalBackground userData={profileData} />
      </TabPanel>
      <TabPanel>
        <Family isOpenedFromAdmin={true} userData={profileData} />
      </TabPanel>
    </TabPanels>
  </Tabs>
</ModalBody>

        </ModalContent>
    </Modal>

  <RejectReasonModal
  isOpen={isRejectOpen}
  onClose={() => setIsRejectOpen(false)}
  leastRef={leastRef}
  rejectReason={rejectReason}
  setRejectReason={setRejectReason}
  onConfirm={confirmReject}
/>

<RejectReasonModal
  isOpen={isApproveOpen}
  onClose={() => setIsApproveOpen(false)}
  leastRef={leastRef}
  rejectReason={approveReason}
  setRejectReason={setApproveReason}
  onConfirm={confirmApprove}
  title="Reason for Acceptance"
  submitLabel="Confirm Approval"
  requireReason={false}
  quickTags={["Verified", "Complete Documents", "Meets Criteria"]}
/>

    </>
    
  )
}
